import React, { FC } from 'react';
import { Pagination } from 'react-bootstrap';

interface Props {
  currentPage: number;
  pageSize: number;
  totalCount: number;
  onChange: (val: number) => void;
}

const PaginationComponent: FC<Props> = ({ currentPage, pageSize, totalCount, onChange }: Props) => {
  const maxPage = Math.ceil(totalCount / pageSize);
  const renderPages = () => {
    const pages: React.ReactNode[] = [];
    for (let i = 1; i <= maxPage; i++) {
      if (i >= currentPage - 2 && i <= currentPage + 2) {
        pages.push(
          <Pagination.Item key={i} active={i === currentPage} onClick={() => onClickPage(i)}>
            {i}
          </Pagination.Item>,
        );
      }
    }
    return pages;
  };
  const onClickPage = (num: number) => {
    if (num > 0 && num <= maxPage) {
      onChange(num);
    }
  };
  return (
    <Pagination>
      <Pagination.First onClick={() => onClickPage(1)} />
      <Pagination.Prev onClick={() => onClickPage(currentPage - 1)} />
      {renderPages()}
      <Pagination.Next onClick={() => onClickPage(currentPage + 1)} />
      <Pagination.Last onClick={() => onClickPage(maxPage)} />
    </Pagination>
  );
};

export default PaginationComponent;
